import { useEffect, useRef, useState } from "react";
import {
  Phone,
  Mail,
  Menu,
  X,
  ChevronDown,
  Factory,
  Cloud,
  Info,
  Users,
} from "lucide-react";
import {
  Code,
  Smartphone,
  RefreshCw,
  ChartColumn,
  Briefcase,
  Database,
  Settings,
  Monitor,
  Globe,
  Headphones,
  Layers,
  Zap,
  ArrowRight,
  Server,
} from "lucide-react";
import { Link } from "react-router-dom";

const Header = () => {

  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  // Desktop dropdown states
  const [servicesDropdownOpen, setServicesDropdownOpen] = useState(false);
  const [odooDropdownOpen, setOdooDropdownOpen] = useState(false);

  // Mobile dropdown states (separate from desktop)
  const [mobileServicesOpen, setMobileServicesOpen] = useState(false);
  const [mobileOdooOpen, setMobileOdooOpen] = useState(false);

  const servicesDropdownRef = useRef(null);
  const odooDropdownRef = useRef(null);

  // Close desktop dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        servicesDropdownRef.current &&
        !servicesDropdownRef.current.contains(event.target)
      ) {
        setServicesDropdownOpen(false);
      }
      if (
        odooDropdownRef.current &&
        !odooDropdownRef.current.contains(event.target)
      ) {
        setOdooDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const isActive = (path) => window.location.pathname === path;

  return (
    <header className="w-full">
        {/* Top Header */}
        <div className="bg-gray-100 py-2 bg-gradient-to-r from-gray-200 to-gray-100 ">
          <div className="container mx-auto px-4">
            <div className="flex flex-col md:flex-row justify-between items-center">
              <div className="flex items-center space-x-6" />
              <div className="flex items-center space-x-4 mt-2 md:mt-0">
                <a
                  href="tel:+1-512-203-7627"
                  className="flex items-center text-gray-700 text-md font-bold hover:text-blue-600 transition-colors"
                >
                  <Phone size={22} className="mr-2" />
                  +1-512-203-7627
                </a>
                <a
                  href="mailto:connect@tissatech.com"
                  className="flex items-center text-gray-700 text-md font-bold hover:text-blue-600 transition-colors"
                >
                  <Mail size={22} className="mr-2" />
                  connect@tissatech.com
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Main Header */}
        <div className="main-sticky-header sticky top-0 z-50 bg-white shadow-md">
          <div >
          <div className="container mx-auto px-4">
            <div className="flex justify-between items-center py-4">
              <Link to="/" className="flex-shrink-0">
                <img
                  src="/assets/images/logos/tissa-logo.png"
                  alt="TISSA Technology Logo"
                  className="h-16"
                />
              </Link>

              {/* Desktop Menu */}
              <nav className="hidden lg:flex items-center space-x-8">
                <Link
                  to="/"
                  className={
                    isActive("/")
                      ? "text-blue-600 font-medium font-bold"
                      : "text-gray-700 hover:text-blue-600 transition-colors font-bold"
                  }
                >
                  Home
                </Link>

                {/* Who We Are */}
                <div className="relative" ref={odooDropdownRef}>
                  <button
                    className="flex items-center text-gray-700 hover:text-blue-600 font-bold transition-colors"
                    onClick={() => setOdooDropdownOpen(!odooDropdownOpen)}
                    aria-expanded={odooDropdownOpen}
                    aria-controls="who-we-are-popover-panel"
                  >
                    Who We Are
                    <ChevronDown
                      size={16}
                      className={`ml-1 transition-transform ${
                        odooDropdownOpen ? "rotate-180" : ""
                      }`}
                    />
                  </button>

                  {odooDropdownOpen && (
                    <div
                      className="absolute left-1/2 z-50 mt-2 transform -translate-x-1/2 rounded-lg bg-white shadow-xl border border-gray-100"
                      id="who-we-are-popover-panel"
                      tabIndex="-1"
                      style={{ width: "200px" }}
                    >
                      <div className="p-4">
                        <ul className="space-y-1">
                          <li>
                            <Link
                              to="/about-us"
                              className="flex items-center text-gray-700 hover:text-blue-600 transition-colors duration-200 py-1 group"
                            >
                              <span className="bg-gray-100 w-6 h-6 rounded-lg flex items-center justify-center mr-2 group-hover:bg-blue-100 transition-colors duration-200">
                                <Info className="w-5 h-5" />
                              </span>
                              <span>About Us</span>
                            </Link>
                          </li>
                          {/* <li>
                            <a
                              href="/our-team"
                              className="flex items-center text-gray-700 hover:text-blue-600 transition-colors duration-200 py-1 group"
                            >
                              <span className="bg-gray-100 w-6 h-6 rounded-lg flex items-center justify-center mr-2 group-hover:bg-blue-100 transition-colors duration-200">
                                <Users className="w-5 h-5" />
                              </span>
                              <span>Our Team</span>
                            </a>
                          </li> */}
                        </ul>
                      </div>
                    </div>
                  )}
                </div>

                {/* Services Dropdown */}
                <div className="relative" ref={servicesDropdownRef}>
                  <button
                    className="flex items-center text-gray-700 hover:text-blue-600 font-bold transition-colors"
                    onClick={() =>
                      setServicesDropdownOpen(!servicesDropdownOpen)
                    }
                    aria-expanded={servicesDropdownOpen}
                    aria-controls="services-popover-panel"
                  >
                    Services
                    <ChevronDown
                      size={16}
                      className={`ml-1 transition-transform ${
                        servicesDropdownOpen ? "rotate-180" : ""
                      }`}
                    />
                  </button>

                  {servicesDropdownOpen && (
                    <div
                      className="absolute left-1/2 z-50 mt-2 transform -translate-x-1/2 rounded-lg bg-white shadow-xl border border-gray-100"
                      id="services-popover-panel"
                      tabIndex="-1"
                      style={{ width: "330px" }}
                    >
                      <div className="p-4">
                        <div>
                          <h3 className="text-lg font-semibold text-gray-800 mb-4 border-b border-gray-100 pb-2">
                            Our Services
                          </h3>
                          <ul className="space-y-1">
                            {[
                              {
                                href: "/services/custom-software-development/",
                                icon: <Code className="w-5 h-5" />,
                                label: "Custom Software Development",
                              },
                              {
                                href: "/services/mobile-app-development/",
                                icon: <Smartphone className="w-5 h-5" />,
                                label: "Mobile Application Development",
                              },
                              {
                                href: "/services/api-development",
                                icon: <Layers className="w-5 h-5" />,
                                label: "API Development",
                              },
                              {
                                href: "/services/integration/",
                                icon: <RefreshCw className="w-5 h-5" />,
                                label: "Integration",
                              },
                              {
                                href: "/services/data-analytics/",
                                icon: <ChartColumn className="w-5 h-5" />,
                                label: "Data Analytics",
                              },
                              {
                                href: "/services/big-data/",
                                icon: <Database className="w-5 h-5" />,
                                label: "Big Data",
                              },
                              {
                                href: "/services/ai-ml-genai",
                                icon: <Monitor className="w-5 h-5" />,
                                label: "AI, ML & GEN AI",
                              },
                              {
                                href: "/services/sap-services",
                                icon: <Server className="w-5 h-5" />,
                                label: "SAP Services",
                              },
                              // {
                              //   href: "/services/sap-services/sap-btp",
                              //   icon: <Cloud className="w-5 h-5" />,
                              //   label: "SAP BTP",
                              // },
                              {
                                href: "/services/odoo-services/",
                                icon: <Globe className="w-5 h-5" />,
                                label: "Odoo Services",
                              },
                              {
                                href: "/services/consulting/",
                                icon: <Briefcase className="w-5 h-5" />,
                                label: "Consulting",
                              },
                            ].map((item, idx) => (
                              <li key={idx}>
                                <Link
                                  to={item.href}
                                  className="flex items-center text-gray-700 hover:text-blue-600 transition-colors duration-200 py-1 group"
                                >
                                  <span className="bg-gray-100 w-6 h-6 rounded-lg flex items-center justify-center mr-2 group-hover:bg-blue-100 transition-colors duration-200">
                                    {item.icon}
                                  </span>
                                  <span>{item.label}</span>
                                </Link>
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                      <div className="bg-gray-50 px-6 py-4 rounded-b-lg border-t border-gray-100 flex justify-between items-center">
                        <Link
                          to="/services/"
                          className="flex items-center text-sm font-medium text-primary hover:text-primary-dark transition-colors duration-200"
                        >
                          View All Services
                          <ArrowRight className="ml-1" />
                        </Link>
                      </div>
                    </div>
                  )}
                </div>

                <Link
                  to="/products"
                  className={
                    isActive("/products")
                      ? "text-blue-600 font-medium font-bold"
                      : "text-gray-700 hover:text-blue-600 transition-colors font-bold"
                  }
                >
                  Products
                </Link>

                <Link
                  to="/career"
                  className={
                    isActive("/career")
                      ? "text-blue-600 font-medium font-bold"
                      : "text-gray-700 hover:text-blue-600 transition-colors font-bold"
                  }
                >
                  Career
                </Link>

                <Link
                  to="/contact-us"
                  className="bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700 transition-colors font-bold"
                >
                  Contact Us
                </Link>
              </nav>

              {/* Mobile Menu Button */}
              <div className="lg:hidden">
                <button
                  onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                  className="text-gray-700 hover:text-blue-600 focus:outline-none"
                >
                  {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
                </button>
              </div>
            </div>
          </div>
        </div>
        {mobileMenuOpen && (
          <div className="lg:hidden bg-white border-t">
            <div className="container mx-auto px-4 py-3">
              <nav className="flex flex-col space-y-4">
                <Link
                  to="/"
                  className={
                    isActive("/")
                      ? "text-blue-600 font-medium py-2"
                      : "text-gray-700 py-2"
                  }
                  onClick={() => setMobileMenuOpen(false)}
                >
                  Home
                </Link>

                {/* Who We Are Dropdown */}
                <div>
                  <button
                    className="flex items-center justify-between w-full text-gray-700 py-2"
                    onClick={() => setMobileOdooOpen(!mobileOdooOpen)}
                  >
                    Who We Are
                    <ChevronDown
                      size={16}
                      className={`transition-transform ${
                        mobileOdooOpen ? "rotate-180" : ""
                      }`}
                    />
                  </button>
                  {mobileOdooOpen && (
                    <div className="pl-4 mt-2 space-y-2">
                      <Link
                        to="/about-us"
                        className="block py-2 text-gray-700"
                        onClick={() => setMobileMenuOpen(false)}
                      >
                        About Us
                      </Link>
                      {/* <a
                        href="/our-team"
                        className="block py-2 text-gray-700"
                        onClick={() => setMobileMenuOpen(false)}
                      >
                        Our Team
                      </a> */}
                    </div>
                  )}
                </div>

                {/* Services Dropdown */}
                <div>
                  <button
                    className="flex items-center justify-between w-full text-gray-700 py-2"
                    onClick={() =>
                      setMobileServicesOpen(!mobileServicesOpen)
                    }
                  >
                    Services
                    <ChevronDown
                      size={16}
                      className={`transition-transform ${
                        mobileServicesOpen ? "rotate-180" : ""
                      }`}
                    />
                  </button>
                  {mobileServicesOpen && (
                    <div className="pl-4 mt-2 space-y-2">
                      <Link
                        to="/services/custom-software-development"
                        className="block py-2 text-gray-700"
                        onClick={() => setMobileMenuOpen(false)}
                      >
                        Custom Software Development
                      </Link>
                      <Link
                        to="/services/mobile-app-development"
                        className="block py-2 text-gray-700"
                        onClick={() => setMobileMenuOpen(false)}
                      >
                        Mobile Application Development
                      </Link>
                      <Link
                        to="/services/api-development"
                        className="block py-2 text-gray-700"
                        onClick={() => setMobileMenuOpen(false)}
                      >
                        API Development
                      </Link>
                      <Link
                        to="/services/integration"
                        className="block py-2 text-gray-700"
                        onClick={() => setMobileMenuOpen(false)}
                      >
                        Integration
                      </Link>
                      <Link
                        to="/services/data-analytics"
                        className="block py-2 text-gray-700"
                        onClick={() => setMobileMenuOpen(false)}
                      >
                        Data Analytics
                      </Link>
                      <Link
                        to="/services/big-data"
                        className="block py-2 text-gray-700"
                        onClick={() => setMobileMenuOpen(false)}
                      >
                        Big Data
                      </Link>
                      <Link
                        to="/services/ai-ml-genai"
                        className="block py-2 text-gray-700"
                        onClick={() => setMobileMenuOpen(false)}
                      >
                        AI, ML & GEN AI
                      </Link>
                      <Link
                        to="/services/sap-services"
                        className="block py-2 text-gray-700"
                        onClick={() => setMobileMenuOpen(false)}
                      >
                        SAP Services
                      </Link>
                      {/* <a
                        href="/services/sap-services/sap-btp"
                        className="block py-2 text-gray-700"
                        onClick={() => setMobileMenuOpen(false)}
                      >
                        SAP BTP
                      </a> */}
                      <Link
                        to="/services/odoo-services"
                        className="block py-2 text-gray-700"
                        onClick={() => setMobileMenuOpen(false)}
                      >
                        Odoo Services
                      </Link>
                      <Link
                        to="/services/consulting"
                        className="block py-2 text-gray-700"
                        onClick={() => setMobileMenuOpen(false)}
                      >
                        Consulting
                      </Link>
                    </div>
                  )}
                </div>

                <Link
                  to="/products"
                  className={
                    isActive("/products")
                      ? "text-blue-600 font-medium py-2"
                      : "text-gray-700 py-2"
                  }
                  onClick={() => setMobileMenuOpen(false)}
                >
                  Products
                </Link>

                <Link
                  to="/career"
                  className={
                    isActive("/career")
                      ? "text-blue-600 font-medium py-2"
                      : "text-gray-700 py-2"
                  }
                  onClick={() => setMobileMenuOpen(false)}
                >
                  Career
                </Link>

                <Link
                  to="/contact-us"
                  className="bg-blue-600 text-white px-6 py-3 rounded text-center hover:bg-blue-700 transition-colors"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  Contact Us
                </Link>
              </nav>
            </div>
          </div>
        )}
        </div>
        
    </header>
  );
};

export default Header;
